package com.tovtalk.ui.screen.chat

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.tovtalk.ui.adaptive.adaptive
import com.tovtalk.ui.theme.TovTalkTheme

@Composable
fun ChatSplitView(
    onNavigateToProfile: (Int) -> Unit,
    onNavigateBack: () -> Unit,
    modifier: Modifier = Modifier,
    onNavigateToSettings: (() -> Unit)? = null,
    initialChatId: Int? = null,
    initialChatName: String = ""
) {
    val listWidth = adaptive(
        compact = 240.dp,
        mediumCompact = 240.dp,
        medium = 240.dp,
        expanded = 300.dp,
        large = 320.dp,
        extraLarge = 360.dp
    )

    var selectedChatId by remember { mutableStateOf(initialChatId) }
    var selectedChatName by remember { mutableStateOf(initialChatName) }

    Row(
        modifier = modifier
            .fillMaxSize()
            .background(TovTalkTheme.colors.backgroundPrimary)
    ) {
        // Chat list panel
        Box(
            modifier = Modifier
                .width(listWidth)
                .fillMaxHeight()
        ) {
            ChatListScreen(
                onNavigateToChat = { receiverId, receiverName ->
                    selectedChatId = receiverId
                    selectedChatName = receiverName
                },
                onNavigateBack = onNavigateBack,
                onChatSelected = { receiverId, receiverName ->
                    selectedChatId = receiverId
                    selectedChatName = receiverName
                },
                selectedChatId = selectedChatId
            )
        }

        VerticalDivider(
            color = TovTalkTheme.colors.border
        )

        // Chat detail panel
        Box(modifier = Modifier.weight(1f).fillMaxHeight()) {
            val bubbleMaxWidth = adaptive(
                compact = Dp.Unspecified,
                mediumCompact = Dp.Unspecified,
                medium = Dp.Unspecified,
                expanded = 480.dp,
                large = 480.dp,
                extraLarge = 480.dp
            )
            val chatId = selectedChatId
            if (chatId != null && chatId > 0) {
                if (bubbleMaxWidth == Dp.Unspecified) {
                    ChatDetailScreen(
                        receiverId = chatId,
                        receiverName = selectedChatName,
                        onNavigateBack = {
                            selectedChatId = null
                            selectedChatName = ""
                        },
                        onNavigateToProfile = { userId ->
                            onNavigateToProfile(userId)
                        },
                        onNavigateToSettings = onNavigateToSettings
                    )
                } else {
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.TopCenter
                    ) {
                        Box(modifier = Modifier.widthIn(max = bubbleMaxWidth).fillMaxHeight()) {
                            ChatDetailScreen(
                                receiverId = chatId,
                                receiverName = selectedChatName,
                                onNavigateBack = {
                                    selectedChatId = null
                                    selectedChatName = ""
                                },
                                onNavigateToProfile = { userId ->
                                    onNavigateToProfile(userId)
                                },
                                onNavigateToSettings = onNavigateToSettings
                            )
                        }
                    }
                }
            } else {
                // Empty state
                Box(
                    modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = "\u05D1\u05D7\u05E8 \u05E9\u05D9\u05D7\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC",
                        style = TovTalkTheme.typography.bodyLarge,
                        color = TovTalkTheme.colors.textSecondary
                    )
                }
            }
        }
    }
}
